<template>
  <div class="form-group" :class="[gridClass, { 'form-group-invalid': errors.length }]">
    <FastInput
      v-model="attribute"
      :placeholder="label"
      :type="type"
      :inner-class="`${errors.length ? 'is-invalid' : ''}`"
      :autofocus="autofocus"
      :autocomplete="autocomplete"
    />
    <p v-if="errors" class="help-block">
      {{ errors[0] }}
    </p>
  </div>
</template>

<script>
import FastInput from '@/apps/shared/components/FastInput.vue'

export default {
  name: 'StepRegistrationInput',
  components: { FastInput },
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    gridClass: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: () => []
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      attribute: this.value
    }
  },
  watch: {
    attribute(newVal, oldVal) {
      this.$emit('attributeChange', newVal)
    }
  }
}
</script>

<style></style>
